<!-- @format -->

<template>
  <div class="content ml-10">
    <div class="md-layout">
      <div
        class="
          ma-0
          pa-0
          md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-30
        "
      >
        <div>
          <div style="display: flex" class="ml-n7">
            <!-- <v-btn icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn> -->

            <h2
              style="
                opacity: 0.8;
                font-family: Nunito Sans;
                font-size: 2rem !important;
                font-weight: 1000 !important;
              "
            >
              <v-icon @click="toggleSidebar()"> mdi-dots-vertical </v-icon>
              {{ userInfo.username }}
              <v-btn icon>
                <v-icon>delete</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>edit</v-icon>
              </v-btn>
            </h2>
          </div>

          <p class="display-33 mt-n2">{{ userInfo.email }}</p>
          <p class="display-33 mt-n2">{{ userInfo.company }}</p>
        </div>
      </div>

      <div
        class="
          ma-0
          pa-0
          md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-40
        "
      ></div>

      <div
        class="
          ma-0
          pa-0
          md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-30
        "
      >
        <div style="display: flex">
          <div style="text-align: right" class="ma-0 pa-0">
            <h2
              style="
                opacity: 0.8;
                font-family: Nunito Sans;
                font-size: 2rem !important;
                font-weight: 1000 !important;
              "
            >
              Artist
            </h2>
            <p class="display-33 mt-n2" style="opacity: 0.8">
              Active since 23.04.2020
            </p>
            <p
              style="font-weight: 400; color: #63b8ff"
              class="display-33 mt-n2"
            >
              Enterprise License
            </p>
          </div>

          <v-badge
            avatar
            overlap
            bottom
            :color="$vuetify.theme.themes[theme].background"
          >
            <v-btn
              @click="popupUploadImage()"
              slot="badge"
              class="mt-n15"
              icon
              :style="{
                background: $vuetify.theme.themes[theme].background,
              }"
            >
              <v-icon size="26">mdi-camera-plus-outline</v-icon>
            </v-btn>
            <v-avatar size="80" class="ml-16">
              <v-icon size="80" v-if="!profileImage"
                >mdi-account-circle-outline</v-icon
              >
              <v-img
                v-if="profileImage"
                :src="profileImage"
                contain
                aspect-ratio="1"
                width="80"
                height="80"
              >
              </v-img>
            </v-avatar>
          </v-badge>
          <!-- <v-menu
            ref="menu1"
            rounded="xl"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="200"
          >
            
            <template v-slot:activator="{ on }">
              <v-badge
                avatar
                overlap
                bottom
                :color="$vuetify.theme.themes[theme].background"
              >
                <v-btn
                  v-on="on"
                  slot="badge"
                  class="mt-n8"
                  icon
                  :style="{
                    background: $vuetify.theme.themes[theme].background,
                  }"
                >
                  <v-icon size="26">mdi-account-settings</v-icon>
                </v-btn>
                <v-avatar size="80" class="ml-16">
                  <v-icon size="80" v-if="!profileImage"
                    >mdi-account-circle-outline</v-icon
                  >
                  <v-img
                    v-if="profileImage"
                    :src="profileImage"
                    contain
                    aspect-ratio="1"
                    width="80"
                    height="80"
                  >
                  </v-img>
                </v-avatar>
              </v-badge>
            </template>
            <v-card
              class="ma-0 pa-0"
              width="200"
              height="230"
              rounded="xl"
              :style="{ background: $vuetify.theme.themes[theme].background }"
              ><div class="pl-7 pr-7 pt-4 ma-0">
                <p class="display-22"><strong>User Profile</strong></p>
                <div class="ma-0 pa-0" style="display: flex">
                  <div class="ma-0 pa-0">
                    <v-btn
                      class="ma-0 pa-0 ml-n2 mt-n1"
                      icon
                      @click="popupUploadImage()"
                    >
                      <v-icon>mdi-camera-plus</v-icon>
                    </v-btn>
                  </div>
                  <div class="ma-0 pa-0 mt-1">
                    <p
                      class="caption-11"
                      style="cursor: pointer"
                      @click="popupUploadImage()"
                    >
                      Change Photo
                    </p>
                  </div>
                </div>
                <v-divider
                  class="pl-5 pr-5 mt-n3"
                  style="border-color: #d3d3d3"
                ></v-divider>
                <div class="ma-0 pa-0" style="display: flex">
                  <div class="ma-0 pa-0">
                    <v-btn class="ma-0 pa-0 ml-n2 mt-n1" icon>
                      <v-icon>mdi-bell-alert-outline</v-icon>
                    </v-btn>
                  </div>
                  <div class="ma-0 pa-0 mt-1">
                    <p class="caption-11" style="cursor: pointer">
                      Notifications
                    </p>
                  </div>
                </div>
                <v-divider
                  class="pl-5 pr-5 mt-n3"
                  style="border-color: #d3d3d3"
                ></v-divider>
                <div class="ma-0 pa-0" style="display: flex">
                  <div class="ma-0 pa-0">
                    <v-btn class="ma-0 pa-0 ml-n2 mt-n1" icon>
                      <v-icon>mdi-upload</v-icon>
                    </v-btn>
                  </div>
                  <div class="ma-0 pa-0 mt-1">
                    <p class="caption-11" style="cursor: pointer">
                      Upgrade License
                    </p>
                  </div>
                </div>
                <v-divider
                  class="pl-5 pr-5 mt-n3"
                  style="border-color: #d3d3d3"
                ></v-divider>
                <div class="ma-0 pa-0" style="display: flex">
                  <div class="ma-0 pa-0">
                    <v-btn class="ma-0 pa-0 ml-n2 mt-n1" icon>
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                  </div>
                  <div class="ma-0 pa-0 mt-1">
                    <p class="caption-11" style="cursor: pointer">Help</p>
                  </div>
                </div>
                <v-divider
                  class="pl-5 pr-5 mt-n3"
                  style="border-color: #d3d3d3"
                ></v-divider>
                <div class="ma-0 pa-0" style="display: flex">
                  <div class="ma-0 pa-0">
                    <v-btn
                      class="ma-0 pa-0 ml-n2 mt-n1"
                      icon
                      @click="userLogout()"
                    >
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </div>
                  <div class="ma-0 pa-0 mt-1">
                    <p
                      class="caption-11"
                      style="cursor: pointer"
                      @click="userLogout()"
                    >
                      Log Out
                    </p>
                  </div>
                </div>
                <v-divider
                  class="pl-5 pr-5 mt-n3"
                  style="border-color: #d3d3d3"
                ></v-divider>
              </div>
            </v-card>
          </v-menu> -->
        </div>
      </div>
    </div>

    <v-divider class="mt-3"></v-divider>

    <div class="md-layout ma-0 pa-0 mt-3">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <div class="ma-0 pa-0" style="display: flex">
          <p class="display22" style="font-weight: 600">
            <strong style="opacity: 0.8">Active Assets</strong>
            <v-btn icon>
              <v-icon size="20">mdi-plus</v-icon>
            </v-btn>
          </p>
        </div>
        <div class="md-layout">
          <div
            v-for="(item, index) in items1"
            :key="index"
            class="
              md-layout-item md-medium-size-25 md-xsmall-size-50 md-size-15
            "
          >
            <v-menu
              rounded="xl"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="300"
              max-height="250"
            >
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-badge overlap :color="badgeColor" :content="item.count">
                    <v-img
                      class="mt-3"
                      rounded
                      contain
                      aspect-ratio="1"
                      width="120"
                      height="120"
                      :src="item.filepng"
                    ></v-img>
                  </v-badge>
                </div>
              </template>

              <v-card
                min-width="300"
                max-height="250"
                rounded="xl"
                class="ma-0 pa-0"
                elevation="0"
              >
                <div class="ma-0 pa-0" style="display: flex">
                  <v-card
                    elevation="0"
                    color="transparent"
                    width="300"
                    height="250"
                    class="ma-0 pa-0 expand"
                  >
                    <v-row class="ma-0 pa-0 pt-3" style="display: flex">
                      <v-col cols="8" class="ma-0 pa-0">
                        <p class="ma-0 pa-0 ml-7 display22">
                          <strong>Your open Task</strong>
                        </p>
                      </v-col>

                      <v-col cols="1"></v-col>
                      <v-col
                        cols="3"
                        class="ma-0 pa-0 mt-n1"
                        style="text-align: center"
                      >
                        <v-badge
                          class="mr-n2"
                          overlap
                          color="blue"
                          :content="item.count"
                        >
                        </v-badge>
                      </v-col>
                    </v-row>

                    <v-card-text class="ma-0 pa-0 mt-2">
                      <div
                        class="ma-0 pa-0 ml-7"
                        style="display: flex"
                        v-for="(item, index) in items2"
                        :key="index"
                      >
                        <v-card
                          class="mt-2"
                          width="200"
                          rounded="xl"
                          outlined
                          elevation="0"
                        >
                          <v-card-text>
                            {{ item.title }}
                          </v-card-text>
                        </v-card>
                        <v-btn
                          icon
                          class="ml-3 mt-6"
                          @click="showDetails = !showDetails"
                        >
                          <v-avatar :color="item.color" size="24">
                            <p
                              v-if="showDetails"
                              class="mt-3"
                              style="color: white; font-weight: 500"
                            >
                              {{ item.number }}
                            </p>
                          </v-avatar>
                        </v-btn>
                        <!--<v-avatar
                          class="ml-3 mt-6"
                          :color="item.color"
                          @click="colorf(item)"
                          size="24"
                        ></v-avatar>
                       -->
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card
                    elevation="0"
                    width="320"
                    rounded="xl"
                    class="ma-0 pa-0"
                    max-height="250"
                    v-if="showDetails"
                    style="overflow: hidden"
                  >
                    <v-divider
                      vertical
                      class="ml-10 mt-3 pb-3"
                      style="position: absolute"
                    ></v-divider>
                    <div style="display: flex" class="ml-15 mb-n1 pt-2">
                      <h5>Change Texture</h5>
                      <p style="font-size: 10px" class="ml-2">3 days ago</p>
                    </div>
                    <v-card
                      elevation="0"
                      width="270"
                      max-height="180"
                      class="expand ma-0 ml-11 pa-0"
                      style="overflow-x: hidden"
                    >
                      <!-- div for comment show -->
                      <div
                        class="ma-0 pa-0 ml-1 mt-1"
                        style="max-height: 150px; width: 77%"
                      >
                        <div
                          style="display: flex"
                          v-for="item in comments"
                          :key="item.content"
                        >
                          <v-card
                            elevation="0"
                            min-height="12"
                            min-width="10"
                            max-width="200"
                            outlined
                            rounded="lg"
                            class="ml-2 mr-3 mt-1 mb-3"
                          >
                            <v-list-item one-line>
                              <v-list-item-content>
                                <p>{{ item.content }}</p>
                              </v-list-item-content>
                            </v-list-item>
                          </v-card>

                          <div class="mt-6 mr-2">
                            <v-avatar
                              v-if="newComment.content"
                              color="yellow"
                              size="18"
                            >
                            </v-avatar>
                          </div>
                        </div>
                      </div>
                    </v-card>
                    <v-divider
                      width="260"
                      style="position: absolute; right: 1em; bottom: 4em"
                    ></v-divider>

                    <div
                      style="
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        display: flex;
                      "
                    >
                      <div>
                        <v-text-field
                          label="Comment"
                          rounded
                          v-model="newComment.content"
                          @keyup.enter="addComment()"
                          style="width: 14em"
                          class="ml-9 mt-2"
                          dense
                        >
                        </v-text-field>
                      </div>

                      <div>
                        <v-menu
                          rounded="xl"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-x
                          max-width="350"
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" icon
                              ><v-icon>mdi-emoticon-happy</v-icon>
                            </v-btn>
                          </template>
                          <VEmojiPicker
                            v-show="true"
                            labelSearch="Search"
                            lang="pt-BR"
                            @select="onSelectEmoji"
                            style="height: 437px"
                            rounded="xl"
                          />
                        </v-menu>
                      </div>
                    </div>
                  </v-card>
                </div>
              </v-card>
            </v-menu>
          </div>
        </div>
      </div>
    </div>
    <v-divider></v-divider>

    <div class="md-layout ma-0 pa-0 mt-3">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <div class="ma-0 pa-0" style="display: flex">
          <p class="display22" style="font-weight: 700">
            <strong style="opacity: 0.8">Progress</strong>
            <v-btn icon>
              <v-icon size="20">mdi-plus</v-icon>
            </v-btn>
          </p>
        </div>

        <v-card
          class="expandalongx ma-0 pa-0 mr-10"
          elevation="0"
          color="transparent"
          height="300"
        >
          <v-row class="ma-0 pa-0">
            <div class="pt-8" style="display: flex">
              <div
                class="pl-5"
                v-for="(item, index) in localItems"
                :key="index"
              >
                <v-row class="ma-0 pa-0" justify="center" align="center">
                  <v-img
                    rounded
                    contain
                    aspect-ratio="1"
                    width="90"
                    height="90"
                    :src="item.filepng"
                    v-bind:style="item.complete ? 'opacity: 0.5' : 'opacity: 1'"
                  ></v-img>
                </v-row>
                <v-row class="ma-0 pa-0" justify="center" align="center">
                  <p
                    class="display-33"
                    v-if="item.complete"
                    :style="{ color: item.color }"
                  >
                    <strong style="font-weight: 900 !important"
                      >Finished</strong
                    >
                  </p>

                  <p
                    v-if="!item.complete"
                    style="visibility: hidden"
                    class="display-33"
                  >
                    OnGoing
                  </p>
                </v-row>
                <v-row class="ma-0 pa-0 ml-n2">
                  <v-icon
                    v-if="index == 2"
                    class="mt-n4 ml-n3"
                    size="12"
                    color="grey"
                    >mdi-sign-pole</v-icon
                  >
                  <show-at breakpoint="mediumAndBelow">
                    <v-banner
                      :dark="lightTheme"
                      :light="darkTheme"
                      class="mt-n2"
                      min-width="20"
                      width="45"
                      height="1"
                      color="grey"
                    >
                    </v-banner>
                  </show-at>
                  <hide-at breakpoint="mediumAndBelow">
                    <v-banner
                      class="mt-n2"
                      min-width="30"
                      width="45"
                      max-width="80"
                      height="1"
                      :dark="lightTheme"
                      :light="darkTheme"
                      color="grey"
                    >
                    </v-banner>
                  </hide-at>
                  <v-icon
                    v-if="item.complete"
                    class="mt-n4"
                    size="20"
                    :color="item.color"
                    >mdi-checkbox-marked-circle-outline
                  </v-icon>
                  <v-icon
                    v-if="!item.complete"
                    class="mt-n4 mr-n5"
                    size="20"
                    :color="item.color"
                  >
                    mdi-circle-medium</v-icon
                  >
                  <v-icon
                    v-if="!item.complete"
                    class="mt-n4"
                    size="20"
                    color="grey"
                  >
                    mdi-circle-outline</v-icon
                  >

                  <show-at breakpoint="mediumAndBelow">
                    <v-banner
                      class="mt-n2 mr-n10"
                      min-width="20"
                      width="52"
                      height="1"
                      :dark="lightTheme"
                      :light="darkTheme"
                      color="grey"
                    >
                    </v-banner>
                  </show-at>
                  <hide-at breakpoint="mediumAndBelow">
                    <v-banner
                      class="mt-n2 mr-n10"
                      min-width="30"
                      width="45"
                      max-width="80"
                      height="1"
                      :dark="lightTheme"
                      :light="darkTheme"
                      color="grey"
                    >
                    </v-banner>
                  </hide-at>
                </v-row>

                <v-row
                  class="ma-0 pa-0 mt-2"
                  justify="center"
                  align="center"
                  style="opacity: 0.7"
                >
                  <p
                    v-if="item.complete"
                    class="caption11"
                    style="font-size: 9px; text-decoration: line-through"
                  >
                    <strong>
                      {{ item.title }}
                    </strong>
                  </p>
                  <!-- <v-spacer ></v-spacer> -->
                  <p
                    v-if="!item.complete"
                    class="caption11"
                    style="font-size: 9px"
                  >
                    {{ item.title }}
                  </p>
                </v-row>

                <v-row class="ma-0 pa-0 mt-n3" justify="center" align="center">
                  <p class="caption11" style="font-size: 9px">
                    <strong>
                      {{ item.created_at }}
                    </strong>
                  </p>
                </v-row>
                <!-- <v-card
                 class="mt-n12"
          elevation="0"
          width="80"
          height="10"
          color="transparent"
          ></v-card> -->
              </div>
            </div>
          </v-row>

          <!-- <v-row class="ma-0 pa-0">
            <div class="pt-8" style="display: flex">
              <div v-for="(item, index) in localItems" :key="index">
                <v-row class="ma-0 pa-0" justify="center" align="center">
                  <v-img
                    rounded
                    contain
                    aspect-ratio="1"
                    width="90"
                    height="90"
                    :src="item.filepng"
                    v-bind:style="item.complete ? 'opacity: 0.5' : 'opacity: 1'"
                  ></v-img>
                </v-row>
                <v-row class="ma-0 pa-0" justify="center" align="center">
                  <p
                    class="display-33"
                    v-if="item.complete"
                    :style="{ color: item.color }"
                  >
                    <strong style="font-weight: 900 !important"
                      >Finished</strong
                    >
                  </p>

                  <p
                    v-if="!item.complete"
                    style="visibility: hidden"
                    class="display-33"
                  >
                    OnGoing
                  </p>
                </v-row>
                <v-row class="ma-0 pa-0" justify="center" align="center">
                  <v-icon
                    v-if="index == 2"
                    class="mt-n2 ml-n3"
                    size="12"
                    color="grey"
                    >mdi-sign-pole</v-icon
                  >
                  <show-at breakpoint="mediumAndBelow">
                    <v-banner
                      :dark="lightTheme"
                      :light="darkTheme"
                      class="mt-n2"
                      min-width="35"
                      height="1"
                      color="grey"
                    >
                    </v-banner>
                  </show-at>
                  <hide-at breakpoint="mediumAndBelow">
                    <v-banner
                      class="mt-n2"
                      min-width="30"
                      width="35"
                      max-width="70"
                      height="1"
                      :dark="lightTheme"
                      :light="darkTheme"
                      color="grey"
                    >
                    </v-banner>
                  </hide-at>
                  <v-icon
                    v-if="item.complete"
                    class="mt-n2"
                    size="20"
                    :color="item.color"
                    >mdi-checkbox-marked-circle-outline
                  </v-icon>
                  <v-icon
                    v-if="!item.complete"
                    class="mt-n2 mr-n5"
                    size="20"
                    :color="item.color"
                  >
                    mdi-circle-medium</v-icon
                  >
                  <v-icon
                    v-if="!item.complete"
                    class="mt-n2"
                    size="20"
                    color="grey"
                  >
                    mdi-circle-outline</v-icon
                  >

                  <show-at breakpoint="mediumAndBelow">
                    <v-banner
                      class="mt-n2"
                      min-width="35"
                      height="1"
                      :dark="lightTheme"
                      :light="darkTheme"
                      color="grey"
                    >
                    </v-banner>
                  </show-at>
                  <hide-at breakpoint="mediumAndBelow">
                    <v-banner
                      class="mt-n2"
                      min-width="30"
                      width="35"
                      max-width="70"
                      height="1"
                      :dark="lightTheme"
                      :light="darkTheme"
                      color="grey"
                    >
                    </v-banner>
                  </hide-at>
                </v-row>
                <v-row
                  class="ma-0 pa-0 mt-2"
                  justify="center"
                  align="center"
                  style="opacity: 0.7"
                >
                  <p
                    v-if="!item.complete"
                    class="caption11"
                    style="font-size: 9px"
                  >
                    {{ item.title }}
                  </p>
                  <p
                    v-if="item.complete"
                    class="caption11"
                    style="font-size: 9px; text-decoration: line-through"
                  >
                    <strong>
                      {{ item.title }}
                    </strong>
                  </p>
                </v-row>
                <v-row class="ma-0 pa-0 mt-n3" justify="center" align="center">
                  <p class="caption11" style="font-size: 9px">
                    <strong>
                      {{ item.created_at }}
                    </strong>
                  </p>
                </v-row>
              </div>
            </div>
          </v-row> -->
        </v-card>
      </div>
    </div>

    <div
      class="popupBack"
      @click.self.prevent="isUploadPopup = !isUploadPopup"
      v-if="isUploadPopup"
    >
      <v-card width="300" height="320" rounded="xl" class="popup">
        <v-form ref="form" v-model="form" class="ma-0 pa-10">
          <v-row align="center" justify="center" class="mt-n6">
            <v-card-title><strong>Upload Avatar</strong></v-card-title>
          </v-row>
          <v-row align="center" justify="center" class="mt-3">
            <v-file-input
              :rules="rules"
              :rounded="true"
              outlined
              dense
              :dark="darkTheme"
              :light="lightTheme"
              accept="image/png, image/jpeg, image/bmp"
              placeholder="Pick an avatar"
              prepend-icon="mdi-camera"
              label="Avatar"
              v-model="imageFile"
            ></v-file-input>
          </v-row>
          <v-row align="center" justify="center" class="mt-n4">
            <v-avatar size="120">
              <v-icon size="120" v-if="!previewImage"
                >mdi-account-circle-outline</v-icon
              >
              <v-img
                contain
                v-if="previewImage"
                width="120"
                height="120"
                :src="previewImage"
              ></v-img>
            </v-avatar>
          </v-row>

          <v-row align="center" justify="center" class="mt-2">
            <v-col cols="6" class="ma-0 pa-0">
              <v-btn
                rounded
                outlined
                :disabled="!imageFile"
                class="display22"
                text
                @click="uploadPiture()"
              >
                Upload
              </v-btn>
            </v-col>

            <v-col cols="6" class="ma-0 pa-0">
              <v-btn
                rounded
                outlined
                class="display22"
                text
                @click="popupUploadImageClose()"
              >
                Cancel
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import { showAt, hideAt } from "vue-breakpoints";
import { VEmojiPicker, emojisDefault, categoriesDefault } from "v-emoji-picker";

import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

import { mapState } from "vuex";

export default {
  name: "ismailpage",

  //  components
  components: {
    hideAt,
    showAt,
    VEmojiPicker,
  },
  // data

  data: function () {
    return {
      lightTheme: false,
      darkTheme: false,
      isUploadPopup: false,
      colorBadge: "white",
      showDetails: false,

      badgeColor: "grey",

      comments: [],
      newComment: {
        content: "",
      },
      items1: [
        { filepng: "/static/assets/images/screenshot.png", count: "1" },
        { filepng: "/static/assets/images/screenshot(1).png", count: "3" },
        { filepng: "/static/assets/images/screenshot(2).png", count: "1" },
        { filepng: "/static/assets/images/screenshot(3).png", count: "6" },
        { filepng: "/static/assets/images/screenshot.png", count: "2" },
        { filepng: "/static/assets/images/screenshot(2).png", count: "1" },
      ],
      items2: [
        {
          color: "yellow",
          title:
            "i am veryfsdfsdfsdfd gdfg dfghrg grtgrt rtgertwertert gerterte happy",
        },
        { color: "blue", title: "why  you sad." },
        { color: "red", title: "i am very happy" },
      ],

      localItems: [
        {
          filepng: "/static/assets/images/screenshot.png",
          colorbanner: "grey",
          color: "#67E6EC",
          title: "Texture Optimized",
          created_at: "20.20.20",
          complete: true,
        },
        {
          filepng: "/static/assets/images/screenshot(1).png",
          colorbanner: "grey",
          color: "#ffd300",
          title: "Texture Optimized",
          created_at: "20.20.20",
          complete: true,
        },
        {
          filepng: "/static/assets/images/screenshot(2).png",
          colorbanner: "grey",
          color: "#ffd300",
          title: "Texture Optimized",
          created_at: "20.20.20",
          complete: false,
        },
        {
          filepng: "/static/assets/images/screenshot.png",
          colorbanner: "grey",
          color: "#67E6EC",
          title: "Texture Optimized",
          created_at: "20.20.20",
          complete: false,
        },
        {
          filepng: "/static/assets/images/screenshot(1).png",
          colorbanner: "grey",
          color: "#ffd300",
          title: "Texture Optimized",
          created_at: "20.20.20",
          complete: false,
        },
        {
          filepng: "/static/assets/images/screenshot(2).png",
          colorbanner: "grey",
          color: "#67E6EC",
          title: "Texture Optimized",
          created_at: "20.20.20",
          complete: false,
        },
        {
          filepng: "/static/assets/images/screenshot.png",
          colorbanner: "grey",
          color: "#ffd300",
          title: "Texture Optimized",
          created_at: "20.20.20",
          complete: false,
        },

        {
          filepng: "/static/assets/images/screenshot(2).png",
          colorbanner: "grey",
          color: "#ffd300",
          title: "Texture Optimized",
          created_at: "20.20.20",
          complete: false,
        },
        {
          filepng: "/static/assets/images/screenshot.png",
          colorbanner: "grey",
          color: "#67E6EC",
          title: "Texture Optimized",
          created_at: "20.20.20",
          complete: false,
        },
        {
          filepng: "/static/assets/images/screenshot(1).png",
          colorbanner: "grey",
          color: "#ffd300",
          title: "Texture Optimized",
          created_at: "20.20.20",
          complete: false,
        },
        {
          filepng: "/static/assets/images/screenshot(2).png",
          colorbanner: "grey",
          color: "#67E6EC",
          title: "Texture Optimized",
          created_at: "20.20.20",
          complete: false,
        },
        {
          filepng: "/static/assets/images/screenshot.png",
          colorbanner: "grey",
          color: "#ffd300",
          title: "Texture Optimized",
          created_at: "20.20.20",
          complete: false,
        },

        // { filepng: "/static/assets/images/screenshot(3).png", count: "6" },
        // { filepng: "/static/assets/images/screenshot.png", count: "2" },
        // { filepng: "/static/assets/images/screenshot(2).png", count: "1" },
      ],

      //userInfo: this.$route.params.userInfo,

      imageFile: "",

      profileImage: "",

      rules: [
        (value) =>
          !value ||
          value.size < 2000000 ||
          "Avatar size should be less than 2 MB!",
      ],

      userID: "",

      userInfo: {
        id: "",
        username: "",
        email: "",
        first_name: "",
        last_name: "",
      },
    };
  },

  //props: ["userInfo"],
  watch: {
    augmentableTheme: function (val) {
      if (val === true) {
        this.colorBadge = "#0e1111";
        this.lightTheme = false;
        this.darkTheme = true;
      } else {
        this.colorBadge = "white";
        this.lightTheme = true;
        this.darkTheme = false;
      }
    },
    imageFile: function () {
      this.previewImage = URL.createObjectURL(this.imageFile);
    },
  },
  computed: {
    ...mapState(["augmentableTheme"]),

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
  mounted() {
    //this.userInfo = this.$route.params.userInfo;
    //this.userID = this.userInfo.id;

    console.log(categoriesDefault);
    console.log("Total emojis:", emojisDefault.length);

    //userInfo

    axios
      .get("/dj-rest-auth/user/", {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Token " + this.getAuthCookie("augmentableUserToken") + "",
        },
      })
      .then((response) => {
        this.userInfo.id = response.data.pk;
        this.userInfo.username = response.data.username;
        this.userInfo.email = response.data.email;
        this.userInfo.first_name = response.data.first_name;
        this.userInfo.last_name = response.data.last_name;

        //this.userInfo = userInfo;

        // console.log(this.userInfo);
        // console.log(this.userInfo.username);
        // console.log("userINFOO");

        axios
          .get("/api/users1/userInfooID/" + this.userInfo.id + "/")
          .then((response) => {
            // console.log(response);
            // console.log(response.data);

            this.profileImage = "" + response.data.profile_image;
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((response) => {
        //console.log("user information22");
        console.log(response);
        //console.log(response.data);
      });
    //userInfo

    if (this.augmentableTheme === true) {
      this.darkTheme = true;
      this.colorBadge = "#0e1111";
    } else {
      this.lightTheme = true;
      this.colorBadge = "white";
    }
  },
  methods: {
    addComment() {
      this.comments.unshift({
        content: this.newComment.content,
      });
      this.newComment.content = " ";
    },

    onSelectEmoji(emoji) {
      this.newComment.content += emoji.data;
    },
    uploadPiture() {
      console.log(this.imageFile);

      let formData = new FormData();
      formData.append("profile_image", this.imageFile);

      axios
        .put(
          "/api/users1/update_user_pic_ID/" + this.userInfo.id + "/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log(response);
          axios
            .get("/api/users1/userInfooID/" + this.userInfo.id + "/")
            .then((response) => {
              //console.log(response.data.profile_image);
              this.profileImage = "" + response.data.profile_image;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);

          axios
            .get("/api/users1/userInfooID/" + this.userInfo.id + "/")
            .then((response) => {
              console.log(response);
              this.profileImage = "" + response.data.profile_image;
            })
            .catch((error) => {
              console.log(error);
            });
        });

      this.isUploadPopup = false;
      this.imageFile = "";
      this.previewImage = "";
      URL.revokeObjectURL(this.imageFile);
    },
    popupUploadImage() {
      this.isUploadPopup = true;
      this.imageFile = "";
      this.previewImage = "";
    },
    popupUploadImageClose() {
      this.isUploadPopup = false;
      this.imageFile = "";
      this.previewImage = "";
      URL.revokeObjectURL(this.imageFile);
    },
    userLogout() {
      this.$store.commit("setAuthentication", false);
      //expiring cookie and delete
      document.cookie =
        "augmentableUserToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      this.$router.push({ name: "account" });
    },
    getAuthCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      console.log(this.$sidebar.showSidebar);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Raleway:200,300,400,600,700,800,900");
@import url("https://fonts.googleapis.com/css?family=Nunito Sans:200,300,400,600,700,800,900");

.popupBack {
  position: fixed;
  width: 100%;
  height: 100%;
  display: block;
  overflow-y: hidden;
  top: 0;
  left: 0;
  background-color: rgba(black, 0.5);
  z-index: 9000;
}
.popup {
  top: 50%;
  left: 50%;
  position: absolute;

  transform: translate(-50%, -50%);
}
.v-card {
  display: flex !important;
  flex-direction: column;
}

.v-card__text {
  //flex-grow: 1;
  //overflow: auto;

  overflow-y: scroll !important;
  -webkit-overflow-scrolling: touch;

  scrollbar-color: #a0a0a0 transparent;
  scrollbar-width: thin;
}

.userAssetTask {
  direction: rtl;
  overflow-y: scroll !important;
  -webkit-overflow-scrolling: touch;

  scrollbar-color: #a0a0a0 transparent;
  scrollbar-width: thin;
}

.v-card__text::-webkit-scrollbar {
  width: 5px;
}
.v-card__text::-webkit-scrollbar-track {
  background: transparent;
}
.v-card__text::-webkit-scrollbar-thumb {
  background: #a0a0a0;
  border-radius: 10px;
}
.expand::-webkit-scrollbar {
  width: 5px;
}
.expand {
  overflow-y: scroll;
  scrollbar-color: #a0a0a0 transparent;
  scrollbar-width: thin;
}
.expand::-webkit-scrollbar-track {
  background: transparent;
}
.expand::-webkit-scrollbar-thumb {
  background: #a0a0a0;
  border-radius: 10px;
}
// .expand::-webkit-scrollbar {
//   display: none;
// }
// .expand {
//   overflow-y: scroll;
//   -ms-overflow-style: none;
//   scrollbar-width: none;
// }

.expandalongx {
  overflow-x: scroll;
  /* -ms-overflow-style: none;  */
  /* scrollbar-width: none;  */
}
</style>
